import { SAMPLE_CSV } from '@/_shared/constants/sampleCsv';
import { AccountStatus, JobStatus, SanityWarningType } from '@/swagger/constants/anagraphics-enums';

export const MOCK_RESPONSE_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE: Blob = SAMPLE_CSV;

export const MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_TEMPLATE = {
  jobId: '12345',
};

export const MOCK_RESPONSE_GET_EMPLOYEES_IMPORTS_BY_JOB_ID = {
  jobId: '12345',
  status: JobStatus.COMPLETED,
};

export const MOCK_RESPONSE_GET_EMPLOYEES_IMPORTS_OVERVIEW = {
  pendingJob: '12345',
  status: 'IDLE' as never,
};

export const MOCK_RESPONSE_GET_EMPLOYEES_STATS = {
  total: 100,
  completed: 100,
  invalid: 0,
  issues: [],
};

export const MOCK_RESPONSE_GET_EMPLOYEES = {
  data: [
    {
      email: 'john.doe@company.com',
      firstName: 'John',
      lastName: 'Doe',
      manager: {
        employeeId: '1',
        email: 'emailManager@company.com',
      },
      role: 'Head Of Engineering',
      area: {
        id: 'engineering',
        name: 'Engineering',
      },
      department: {
        id: 'digital-products',
        name: 'Digital Products',
      },
      fiscalCode: 'FRTNDL80A01H501Z',
      jobLevel: 'Senior',
      seniority: '2 years',
      id: '1',
      birthDate: '1980-01-01',
      issues: [],
      isComplete: true,
      status: AccountStatus.ENABLED,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      email: 'john.doe@company.com',
      firstName: 'John',
      lastName: 'Doe',
      manager: {
        employeeId: '1',
        email: 'manager@company.com',
      },
      role: 'Software Engineer Expert',
      area: {
        id: 'engineering',
        name: 'Engineering',
      },
      department: {
        id: 'digital-products',
        name: 'Digital Products',
      },
      fiscalCode: 'FCLCDE85A01H501Z',
      jobLevel: 'Senior',
      seniority: '2 years',
      birthDate: '1985-01-01',
      id: '2',
      issues: [],
      isComplete: false,
      status: AccountStatus.PENDING,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ],
  totalItems: 2,
};

export const MOCK_RESPONSE_GET_UNASSIGNED_EMPLOYEES = {
  data: [],
  totalItems: 0,
};

export const MOCK_RESPONSE_GET_EMPLOYER_BY_ID = {
  email: 'john.doe@company.com',
  firstName: 'John',
  lastName: 'Doe',
  emailManager: 'emailManager@company.com',
  role: 'Head Of Engineering',
  area: {
    id: 'engineering',
    name: 'Engineering',
  },
  birthDate: '1980-01-01',
  department: {
    id: 'digital-products',
    name: 'Digital Products',
  },
  fiscalCode: 'DRTNDL80A01H501Z',
  jobLevel: 'Senior',
  seniority: '2 years',
  id: '1',
  issues: [],
  isComplete: true,
  status: AccountStatus.ENABLED,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const MOCK_RESPONSE_GET_EMPLOYEES_IMPORTS_STATS = {
  total: 100,
  completed: 80,
  invalid: 20,
  issues: [],
};

export const MOCK_RESPONSE_GET_EMPLOYEES_IMPORT = {
  data: [
    {
      id: '1',
      email: 'john.doe@company.com',
      firstName: 'John',
      lastName: 'Doe',
      emailManager: 'emailManager@company.com',
      role: 'Head Of Engineering',
      division: 'Digital Products',
      fiscalCode: 'FCLCDE85A01H501Z',
      organizationId: 'org-1',
      issues: [],
      isComplete: false,
    },
    {
      id: '2',
      email: 'john.doe@company.com',
      firstName: 'John',
      lastName: 'Doe',
      fiscalCode: 'FCLCDE85A01H501Z',
      role: 'Software Engineer Expert',
      division: 'Digital Products',
      organizationId: 'org-1',
      issues: [],
      isComplete: false,
    },
  ],
  totalItems: 2,
};

export const MOCK_RESPONSE_PUT_EMPLOYEES_IMPORT = {
  id: '2',
  email: 'john.doe@company.com',
  firstName: 'John',
  lastName: 'Doe',
  fiscalCode: 'FCLCDE85A01H501Z',
  role: 'Software Engineer Expert',
  division: 'Digital Products',
  organizationId: 'org-1',
  issues: [],
  isComplete: false,
};

export const MOCK_RESPONSE_PUT_EMPLOYER_BY_ID = undefined;

export const MOCK_RESPONSE_DELETE_EMPLOYER_BY_ID = undefined;

export const MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_CONFIRM = {
  status: 'ok',
};

export const MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_ABORT = {
  status: 'aborted',
};

export const MOCK_RESPONSE_GET_EMPLOYEES_FILTERS = {
  departments: [
    {
      key: 'software-engineer',
      value: 'Software Engineer',
    },
  ],
  roles: [
    {
      key: 'engineer',
      value: 'Engineer',
    },
  ],
};

export const MOCK_RESPONSE_POST_EMPLOYER_BY_ID_ENABLE = undefined;
export const MOCK_RESPONSE_POST_EMPLOYER_BY_ID_DISABLE = undefined;

export const MOCK_RESPONSE_POST_EMPLOYEE = {
  id: '2',
  email: 'john.doe@company.com',
  firstName: 'John',
  lastName: 'Doe',
  fiscalCode: 'FCLCDE85A01H501Z',
  role: 'Software Engineer Expert',
  issues: [],
  isComplete: true,
  status: AccountStatus.NOT_INVITED,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const MOCK_RESPONSE_POST_EMPLOYEES_DELETE_CHECK = {
  warnings: [
    {
      type: SanityWarningType.DEPARTMENT_LOSES_MANAGER,
      departmentKey: 'altermaind',
      departmentName: 'altermAInd',
    },
    {
      type: SanityWarningType.DEPARTMENT_BECOMES_EMPTY,
      departmentKey: 'altermaind',
      departmentName: 'altermAInd',
    },
  ],
};

export const MOCK_RESPONSE_POST_EMAIL_ALREADY_EXIST = false;
